<div class="action-arrow__content">
	{{ status }}
</div>
